"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactor = void 0;
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireDefault(require("react"));
var _state = require("../../../state");
var _ui = require("../../ui");
var _layout = require("../layout");
var _TwoFactor = require("../TwoFactor");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TwoFactor = function TwoFactor(_ref) {
  var authCode = _ref.authCode,
    loginPath = _ref.loginPath;
  var _useOAuth = (0, _state.useOAuth)(),
    _useOAuth$google = _useOAuth.google,
    loginLoading = _useOAuth$google.loginLoading,
    login = _useOAuth$google.login;
  var _useTranslation = (0, _reactI18next.useTranslation)('libAuth'),
    t = _useTranslation.t;
  var history = (0, _reactRouterDom.useHistory)();
  var _useTwoFactor = (0, _state.useTwoFactor)(),
    reset = _useTwoFactor.reset;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_layout.LayoutBackTitle, {
    onClick: function onClick() {
      reset();
      history.push(loginPath);
    }
  }, t('backToLogin')), /*#__PURE__*/_react.default.createElement(_layout.LayoutBodyCard, null, /*#__PURE__*/_react.default.createElement(_ui.CardBody, null, /*#__PURE__*/_react.default.createElement(_TwoFactor.TwoFactor, {
    submitLoading: loginLoading,
    onGoogleFormSubmit: function onGoogleFormSubmit(_ref2) {
      var code = _ref2.code;
      return login({
        token: code,
        code: authCode
      });
    }
  }))));
};
exports.TwoFactor = TwoFactor;